import Vue from 'vue'
import Vuelidate from 'vuelidate'
import VuelidateErrorExtractor, { templates } from 'vuelidate-error-extractor'
import FormGroup from '@/components/FormGroup'
import FormSummary from '@/components/FormSummary'

Vue.use(Vuelidate)
Vue.use(VuelidateErrorExtractor, {
  i18n: 'validation',
  i18nAttributes: {
    __default: 'attributes'
  }
})

Vue.component('FormWrapper', templates.FormWrapper)
Vue.component('FormSummary', FormSummary)
Vue.component('FormGroup', FormGroup)
